import { ScreenEnum, useScreen } from 'feature/screenMode'
import { useEffect, useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'

export const useEditFitterDataFormUtils = () => {
  const [viewMode, setViewMode] = useState<string>('form')

  const {
    authInfo: { isLoading },
  } = useAppSelector(state => state.auth)

  const screen = useScreen()
  const { setIsDirtyAddress } = useActions()

  useEffect(() => {
    setIsDirtyAddress(false)
    return () => {
      setIsDirtyAddress(false)
    }
  }, [])

  const openCityPopupHandler = () => {
    if (screen !== ScreenEnum.desktop) {
      setViewMode('popup')
    }
  }

  return {
    openCityPopupHandler,
    viewMode,
    setViewMode,
    isLoading,
  }
}
